import {
    Mta
} from "./index.js";
import {
    createRouteMap
} from "./route";
export const mta = new Mta()
// 解耦
const navigateTo = uni.navigateTo
const redirectTo = uni.redirectTo
const reLaunch = uni.reLaunch
const switchTab = uni.switchTab
const navigateBack = uni.navigateBack
export default {
    navigateTo: ({
        url,
        success,
        fail,
        complete
    }) => {
        const routeMap = createRouteMap()
        mta.setEvent('leaveStr', routeMap)
        navigateTo({
            url: url,
            success: function () {
                mta.setEvent('entryStr', url)
                success && success()
            },
            fail(err) {
                fail && fail()
            },
            complete() {
                complete && complete()
            }
        });
    },
    redirectTo: ({
        url,
        success,
        fail,
        complete
    }) => {
        const routeMap = createRouteMap()
        mta.setEvent('leaveStr', routeMap)
        redirectTo({
            url: url,
            success: function () {
                mta.setEvent('entryStr', url)
                success && success()
            },
            fail(err) {
                fail && fail()
            },
            complete() {
                complete && complete()
            }
        });
    },
    reLaunch: ({
        url,
        success,
        fail,
        complete
    }) => {
        const routeMap = createRouteMap()
        mta.setEvent('leaveStr', routeMap)
        reLaunch({
            url: url,
            success: function () {
                mta.setEvent('entryStr', url)
                success && success()
            },
            fail(err) {
                fail && fail()
            },
            complete() {
                complete && complete()
            }
        });
    },
    switchTab: ({
        url,
        success,
        fail,
        complete
    }) => {
        const routeMap = createRouteMap()
        mta.setEvent('leaveStr', routeMap)
        switchTab({
            url: url,
            success: function () {
                success && success()
                mta.setEvent('entryStr', url)
            },
            fail(err) {
                fail && fail()
            },
            complete() {
                complete && complete()
            }
        });
    },
    navigateBack: (params) => {
        params = params ? params : {
            delta: 1
        }
        const routeMap = createRouteMap()
        mta.setEvent('leaveStr', routeMap)
        navigateBack({
            delta: params.delta
        });
        // 
        mta.setEvent('entryStr', routeMap)
    }
}